import { FaRegFileAlt, FaLinkedin, FaGithub } from 'react-icons/fa';
import RightRail from '../components/RightRail';

export default function Contact() {
    const links = [
        {
            label: 'Resume',
            href: '/resume.pdf',
            Icon: FaRegFileAlt,
        },
        {
            label: 'LinkedIn',
            href: 'https://www.linkedin.com/in/erickacifuentes/',
            Icon: FaLinkedin,
        },
        {
            label: 'GitHub',
            href: 'https://github.com/ErickCif',
            Icon: FaGithub,
        },
    ];

    return (
        <div className='experience'>
            <RightRail>
                <p className="page-right__header">Tell me about your favorite algorithm or favorite poker hand.</p>
                <p className="page-right__header page-right__subheader">(Mine are Ford-Fulkerson & K10s)</p>
                <ul>
                    {links.map(({ label, href, Icon }) => (
                        <li key={label}>
                            <a href={href} target="_blank" rel="noopener noreferrer">
                                {label}
                                <Icon className="icon" />
                            </a>
                        </li>
                    ))}
                </ul>
            </RightRail>
        </div>

    );
}
